import React, {memo, useEffect, useState} from "react";
import {Pagination} from 'react-bootstrap';
import dynamic from "next/dynamic";
import {useRouter} from 'next/router'
import Utils from "@/utils/Default/Utils";
import IntersectionObserverSSR from "../Layout/Resource/IntersectionObserverSSR";

const DynamicSeePaginatorButton = dynamic(() =>
    import('./SeePaginatorButton')
)
const Paginator = memo(({
                       listItemsCount,
                       productItemCount,
                       seeProducts,
                       links,
                       activePage,
                       pager,
                       isSearch,
                       categoryView
                   }) => {
    const [firstLoad, setFirstLoad] = useState(true)
    const {pageCount, firstPageUrl, lastPageUrl, nextPageUrl, previousPageUrl} = pager;
    const router = useRouter()
    useEffect(() => {
        setFirstLoad(false)
    }, [])
    return (
        <>
            <IntersectionObserverSSR>
                {(activePage < pageCount) &&
                    <DynamicSeePaginatorButton title={'Voir plus'} label={'Voir plus'} className={'dp__content-next'}
                                               context={'seeMore'}
                                               seeProducts={seeProducts}/>
                }
                <p className="dp__content__numberProductsRatio">{listItemsCount} / {productItemCount} {listItemsCount > 1 ? 'produits' : 'produit'}</p>
            </IntersectionObserverSSR>
            {isSearch &&
                <div className="target2sell" id='PPNA1QL127P68J-2000-1464' />
            }
            <IntersectionObserverSSR>
                <div className="dp__content__navigation">
                    <p className="dp__content__navigation-numberProducts">
                        <strong>{productItemCount}</strong> produits</p>
                    <Pagination>
                        {activePage > 1 ? (
                            <Pagination.First href={Utils.getUpdatedUrl(firstLoad, router.asPath, firstPageUrl, categoryView)}
                            />
                        ) : (
                            <Pagination.First disabled/>
                        )}
                        {activePage > 1 ? (
                            <Pagination.Prev href={Utils.getUpdatedUrl(firstLoad, router.asPath, previousPageUrl, categoryView)}
                            />
                        ) : (
                            <Pagination.Prev disabled/>
                        )}
                        {links.map((x, idx) =>
                            x === "..." ? (
                                <Pagination.Ellipsis disabled/>
                            ) : (
                                <Pagination.Item
                                    href={Utils.getUpdatedUrl(firstLoad, router.asPath, x, categoryView)}
                                    active={activePage === parseInt(x)}
                                >
                                    {x}
                                </Pagination.Item>
                            )
                        )}
                        {activePage < pageCount ? (
                            <Pagination.Next href={Utils.getUpdatedUrl(firstLoad, router.asPath, nextPageUrl, categoryView)}
                            />
                        ) : (
                            <Pagination.Next disabled/>
                        )}
                        {activePage < pageCount ? (
                            <Pagination.Last href={Utils.getUpdatedUrl(firstLoad, router.asPath, lastPageUrl, categoryView)}
                            />
                        ) : (
                            <Pagination.Last disabled/>
                        )}
                    </Pagination>
                </div>
            </IntersectionObserverSSR>
        </>
    )
})
export default Paginator;